import { cn } from '@/lib/utils';

interface SectionHeadingProps {
  children: string;
  className?: string;
}

export function SectionHeading({ children, className }: SectionHeadingProps) {
  return <h2 className={cn('mt-3 text-xs font-medium leading-4 text-gray-800', className)}>{children}</h2>;
}
